import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useApi } from '../hooks/useApi';

const ModeloAtencion = () => {
  const { modeloAtencion, getModeloAtencion } = useApi();

  useEffect(() => {
    getModeloAtencion();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <p
        dangerouslySetInnerHTML={{
          __html: modeloAtencion.data?.texto_completo,
        }}
      />
    </Container>
  );
};

export default ModeloAtencion;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;
